export default "__VITE_ASSET__17991c2b__"